import fuzzy from 'fuzzy';

/**
 * Perform a fuzzy search on a collection of `T` given a string `query` and a criteria function `queryCriteria` for all T.
 *
 * @param queryCriteria A function that for any `T` returns the string criteria on which the query will be matched.
 */
export function fuzzySearchBuilder<T>(queryCriteria: (t: T) => string | ReadonlyArray<string>) {
  return (list: ReadonlyArray<T>, query: string): ReadonlyArray<T> => {
    const lowercaseQuery = query.toLowerCase();

    return list
      .map((item) => {
        const stringOrStringArray: string | ReadonlyArray<string> = queryCriteria(item);
        const strings = Array.isArray(stringOrStringArray) ? stringOrStringArray : [stringOrStringArray];

        const allScores = strings.map((string) => {
          const matchResult = fuzzy.match(query, string);
          let score = matchResult ? matchResult.score : 0;

          // Manually give a higher score when the prefix matches.
          string.split(' ').forEach((str: string) => {
            if (str.toLowerCase().startsWith(lowercaseQuery)) {
              score += 1;
            }
          });

          // Manually give higher priority to default empty strings.
          if (string.trim() === '') {
            score += 1337;
          }

          return score;
        });

        const maxScore = Math.max(...allScores);
        return {item, score: maxScore};
      })
      .filter(({score}) => score > 0)
      .sort((a, b) => b.score - a.score)
      .map((r) => r.item);
  };
}
